import React from "react";
import SignupComponent from "../../components/signup-component";
import Cookies from "js-cookie";
import { Navigate } from "react-router-dom";

const SignUp = () => {
  const token = Cookies.get("baf_base_user_token");

  // If token exists, redirect before rendering
  if (token) {
    return <Navigate to="/" replace />;
  }

  return (
    <div>
      <SignupComponent />
    </div>
  );
};

export default SignUp;
